import React, { useState } from 'react';
import styles from './BrandEditor.module.css';

interface BrandEditorProps {
  siteName: string;
  logoUrl: string;
  faviconUrl: string;
  onChange: (field: keyof BrandEditorProps, value: string) => void;
}

export const BrandEditor: React.FC<BrandEditorProps> = ({
  siteName,
  logoUrl,
  faviconUrl,
  onChange,
}) => {
  const [logoPreview, setLogoPreview] = useState<string | null>(logoUrl || null);
  const [faviconPreview, setFaviconPreview] = useState<string | null>(faviconUrl || null);

  const handleLogoUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value;
    onChange('logoUrl', url);
    setLogoPreview(url || null);
  };

  const handleFaviconUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value;
    onChange('faviconUrl', url);
    setFaviconPreview(url || null);
  };

  const handleImageError = (type: 'logo' | 'favicon') => {
    if (type === 'logo') {
      setLogoPreview(null);
    } else {
      setFaviconPreview(null);
    }
  };

  return (
    <div className={styles.brandEditor}>
      <div className={styles.formGroup}>
        <label>Site Name</label>
        <input
          type="text"
          value={siteName}
          onChange={(e) => onChange('siteName', e.target.value)}
          placeholder="Brand name"
          className={styles.textInput}
        />
      </div>

      <div className={styles.formGroup}>
        <label>Logo URL</label>
        <input
          type="text"
          value={logoUrl}
          onChange={handleLogoUrlChange}
          placeholder="https://example.com/logo.png"
          className={styles.textInput}
        />
        {logoPreview && (
          <div className={styles.imagePreview}>
            <img
              src={logoPreview}
              alt="Logo preview"
              onError={() => handleImageError('logo')}
            />
            <span className={styles.previewLabel}>Logo Preview</span>
          </div>
        )}
      </div>

      <div className={styles.formGroup}>
        <label>Favicon URL</label>
        <input
          type="text"
          value={faviconUrl}
          onChange={handleFaviconUrlChange}
          placeholder="https://example.com/favicon.ico"
          className={styles.textInput}
        />
        {faviconPreview && (
          <div className={styles.imagePreview}>
            <img
              src={faviconPreview}
              alt="Favicon preview"
              className={styles.favicon}
              onError={() => handleImageError('favicon')}
            />
            <span className={styles.previewLabel}>Favicon Preview</span>
          </div>
        )}
      </div>

      <div className={styles.brandPreview}>
        <label>Brand Preview</label>
        <div className={styles.previewHeader}>
          {logoPreview && (
            <img src={logoPreview} alt="Logo" className={styles.previewLogo} />
          )}
          <span className={styles.previewSiteName}>{siteName || 'Site Name'}</span>
        </div>
      </div>
    </div>
  );
};
